
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { Message } from 'element-ui';
import { createRole, updateRole } from '@/api/role';

export default extend(dialog, {
    namespaced: true,
    state: {
        form: {},
        isEdit: false
    },
    actions: {
        async confirm({ dispatch, state }) {
            const { isEdit, form } = state;
            if (isEdit) {
                await updateRole(form.id, form)
            } else {
                await createRole(form)
            }
            Message({
                message: '操作成功！',
                type: 'success'
            });
            dispatch('closeDialog');
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/role/add-edit-role-dialog.js